import { getSiteId, useAppSelector } from '@la/services';
import { getLAHostnameParts } from '@la/utilities';
import { useGetUserSummaryQuery } from 'redux/services/singleActivityApi';
import { UserSummaryResponse } from 'redux/services/types/singleActivity';

type UseUserSummaryProps = {
  activityId: number;
  isGame: boolean;
};

export function useUserSummary({ activityId, isGame }: UseUserSummaryProps) {
  const { subdomain } = getLAHostnameParts();
  const siteId = useAppSelector(getSiteId) ?? '';
  const { data: userSummary } = useGetUserSummaryQuery(
    {
      activityId,
      siteId,
      subdomain,
      isGame,
    },
    { skip: activityId === 0 }
  );

  return {
    getUserSummary: () => getUserSummary(userSummary),
  };
}

/**
 *
 * @param userSummary
 * @returns userSummaries
 */
function getUserSummary(userSummary?: UserSummaryResponse) {
  return userSummary ? userSummary.userSummaries : [];
}
